import { render, staticRenderFns } from "./bind_wechat.vue?vue&type=template&id=774f0728"
import script from "./bind_wechat.vue?vue&type=script&lang=js"
export * from "./bind_wechat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports